<template>
  <div v-if="itemRelation" class="text-left">
    <h5>
      {{ $t("form." + field) }}
    </h5>
    <v-row v-for="(item, index) in newRelations" :key="index">
      <v-col cols="12" sm="5">
        <v-text-field
          :value="item[itemsFromdbText]"
          :label="$t('form.not_item_relation')"
          required
          outlined
          readonly
        ></v-text-field>
      </v-col>
      <v-col cols="11" sm="6" v-if="item.id !== 'delete'">
        <v-autocomplete
          v-model="item.id"
          :items="itemsFromdb"
          :item-text="itemsFromdbText"
          item-value="id"
          return-object
          :label="$t('form.select_item_relation')"
          required
          outlined
          :readonly="readOnly"
          :ref="`select${index}`"
          @change="changeSelect($event, item)"
        ></v-autocomplete>
      </v-col>
      <v-col cols="11" sm="6" v-else class="rounded">
        <v-text-field
          outlined
          readonly
          :value="$t('form.relation_item_removed')"
        ></v-text-field>
      </v-col>
      <v-col cols="1" v-if="item.id !== 'delete'">
        <v-btn icon color="red" class="mt-2" @click="deleteItem(item)">
          <v-icon>
            mdi-delete
          </v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row class="justify-end">
      <v-col cols="5" sm="3" md="2" lg="1">
        <v-btn @click="submit" :disabled="save || readOnly" color="light-green">
          {{ $t("button.save") }}
        </v-btn></v-col
      >
    </v-row>
  </div>
  <div v-else class="text-left">
    <h5>
      {{ $t("form." + field) }}
    </h5>
    <v-row>
      <v-col cols="12" md="6">
        <v-alert dense text type="success">
          {{ $t("process.itemsRelation.correct") }}
        </v-alert>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import axios from "axios";

export default {
  props: {
    field: String,
    dataModOp: Object,
    itemsFromdb: Array,
    itemsFromdbText: String,
    state: String,
    original_items: {
      type: Array,
      default: () => []
    }
  },
  name: "AssignRelationField",
  data: () => ({
    newRelations: [],
    save: true
  }),

  created() {
    this.initialize();
  },

  computed: {
    itemRelation: function() {
      return this.newRelations.length > 0;
    },

    readOnly: function() {
      return this.state === "PC";
    }
  },

  mounted() {
    this.loadSelectedOptions();
  },
  methods: {
    initialize() {
      if (
        this.dataModOp.supervisor !== undefined &&
        this.dataModOp.supervisor[this.field] !== undefined
      ) {
        this.newRelations = this.dataModOp.supervisor[this.field];
      } else {
        this.newRelations = this.$R.clone(
          this.original_items.filter(item => item.id == null)
        );
      }
    },

    loadSelectedOptions() {
      this.newRelations.forEach((item, index) => {
        let name = "select" + index;
        if (item.id != null) {
          this.itemsFromdb.forEach(itemFromdb => {
            if (item.id === itemFromdb.id) {
              this.$refs[name][0].selectedItems = [];
              this.$refs[name][0].selectedItems.push(itemFromdb);
            }
          });
        }
      });
    },

    submit() {
      let data = {
        data: {
          user: this.dataModOp.user,
          supervisor: {}
        }
      };
      if (this.dataModOp.supervisor !== undefined) {
        data["data"]["supervisor"] = this.dataModOp.supervisor;
      }
      data["data"]["supervisor"][this.field] = this.newRelations;
      let path =
        this.$store.state.endpoint +
        "/moderatedOperations/" +
        this.$route.params.id;
      axios
        .patch(path, data)
        .then(response => {
          this.$emit("update-modOp-data", data.data);
          this.$store.commit("alert", {
            color: "success",
            text: this.$t("form.select_item_relation_success")
          });
          this.save = true;
        })
        .catch(error => {
          console.log(error);
          console.log(error.response.data);
          this.$store.commit("alert", {
            color: "error",
            text: error.response.data
          });
        });
    },
    changeSelect(itemSelected, itemRelation) {
      itemRelation.id = itemSelected.id;
      this.save = false;
    },
    deleteItem(item) {
      this.newRelations.find(o => o.temporalId === item.temporalId).id =
        "delete";
      this.save = false;
    }
  }
};
</script>

<style scoped></style>
